'use client';

import { useState, type FC, type ReactNode } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { Dialog } from '@packages/shared/src/ui/Dialog/Dialog';
import { DialogHeader } from '@packages/modules/src/Dialog/DialogHeader/DialogHeader.client';
import { DialogContent } from '@packages/shared/src/ui/Dialog/DialogContent/DialogContent';
import { dispatchDisplayOverlayTracking } from '@packages/shared/src/ui/Dialog/dispatchDialogOverlayTracking';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import { FilterSettingsMobileButton } from '../FilterSettingsMobileButton/FilterSettingsMobileButton';

export type FilterSettingsMobileCategoryDialogButtonProps = {
  /** Renders the content of the categories dialog, don't forget to invoke the closeDialog callback on selection */
  children: (closeDialog: () => void) => ReactNode;
};

const messages = defineMessages({
  categoryButton: {
    id: 'filters.selection.mobile.categoryButton.text',
    defaultMessage: 'Kategorien',
  },
});

export const FilterSettingsMobileCategoryDialogButton: FC<
  FilterSettingsMobileCategoryDialogButtonProps
> = ({ children }) => {
  const { formatMessage } = useIntl();
  const dispatchGTMEvent = useTracking();
  const [isOpen, setIsOpen] = useState(false);

  const open = () => {
    setIsOpen(true);
    dispatchDisplayOverlayTracking({
      eventDispatcher: dispatchGTMEvent,
      displayTrackingProps: {
        category: 'display-overlay',
        label: formatMessage(messages.categoryButton),
      },
    });
  };
  const close = () => setIsOpen(false);

  return (
    <>
      <FilterSettingsMobileButton onClick={open}>
        {formatMessage(messages.categoryButton)}
      </FilterSettingsMobileButton>
      <Dialog
        className={`${isOpen ? 'animate-slide-in-left' : ''} will-change-transform`}
        isOpen={isOpen}
        onClose={close}
      >
        <DialogHeader onBack={close} onClose={close}>
          {formatMessage(messages.categoryButton)}
        </DialogHeader>
        <DialogContent className="px-0 py-0">{children(close)}</DialogContent>
      </Dialog>
    </>
  );
};
